
import { defineComponent } from "vue";
import { Cropper, Preview } from "vue-advanced-cropper";
import IconSave from "@/components/icons/IconSave.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import { useUserStore } from "@/stores/UserStore";
import { UsersAPI } from "@/api/UsersAPI";
import "vue-advanced-cropper/dist/style.css";

export default defineComponent({
  name: "AccountSettings",
  components: {
    Preview,
    IconSave,
    IconEdit,
    Cropper,
    // Preview,
  },
  setup() {
    const userStore = useUserStore();
    const usersAPI = new UsersAPI();

    return { userStore, usersAPI };
  },
  data(): {
    img: string;
    imageForUpload: { src: string | null; type: string | null };
    result: { coordinates: object | null; image: object | null } | null;
    userFormElementsState: {
      nameInputLock: boolean;
      name: string;
      nameValidation: {
        isValid: boolean;
        message: string;
      };
      surnameInputLock: boolean;
      surname: string;
      surnameValidation: {
        isValid: boolean;
        message: string;
      };
    };
  } {
    return {
      img: "data:image/jpeg;base64,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",
      imageForUpload: {
        src: null,
        type: null,
      },
      result: {
        coordinates: null,
        image: null,
      },
      userFormElementsState: {
        nameInputLock: true,
        name: "",
        nameValidation: {
          isValid: true,
          message: "",
        },

        surnameInputLock: true,
        surname: "",
        surnameValidation: {
          isValid: true,
          message: "",
        },
      },
    };
  },
  created() {
    this.userFormElementsState.name = this.userStore.user?.name ?? "";
    this.userFormElementsState.surname = this.userStore.user?.surname ?? "";
  },
  methods: {
    reset() {
      this.imageForUpload = {
        src: null,
        type: null,
      };
      this.result = {
        coordinates: null,
        image: null,
      };
    },
    loadImage(event: any) {
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.imageForUpload.src) {
          URL.revokeObjectURL(this.imageForUpload.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          if (e?.target !== null) {
            // Note: arrow function used here, so that "this.image" refers to the image of Vue component
            this.imageForUpload = {
              // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
              src: blob,
              // Determine the image type to preserve it during the extracting the image from canvas:
              type: this.getMimeType(e.target.result, files[0].type),
            };
          }
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
    destroyed() {
      // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.imageForUpload.src) {
        URL.revokeObjectURL(this.imageForUpload.src);
      }
    },
    changeUserImage({ coordinates, image }: { coordinates: any; image: any }) {
      this.result = {
        coordinates,
        image,
      };
    },
    getMimeType(file: any, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4);
      let header = "";
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16);
      }
      switch (header) {
        case "89504e47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
          return "image/jpeg";
        default:
          return fallback;
      }
    },

    uploadImage() {
      const { canvas } = (this.$refs.cropper as typeof Cropper).getResult();
      if (canvas) {
        console.log('imageForUploadtype:', this.imageForUpload.type)
        canvas.toBlob(async (file: Blob) => {
          console.log('file:', file.type)

          // TODO catch errors
          await this.usersAPI.uploadUserImage(file);
          // this.appStore.addNotification("Uploaded", NotificationType.SUCCESS);
          // TODO replace on url from response
          await this.userStore.getCurrentUser();
          this.destroyed();
          this.reset();
        }, this.imageForUpload.type);
      }
    },

    changeName() {
      this.userFormElementsState.nameInputLock = false;
    },
    async saveName() {
      if (
        this.userStore.user &&
        this.userFormElementsState.nameValidation.isValid &&
        this.userFormElementsState.name !== this.userStore.user.name
      ) {
        await this.usersAPI.updateUser({
          _id: this.userStore.user._id,
          name: this.userFormElementsState.name,
        });
        await this.userStore.getCurrentUser();
      }
      this.userFormElementsState.nameInputLock = true;
    },

    changeSurname() {
      this.userFormElementsState.surnameInputLock = false;
    },
    async saveSurname() {
      if (
        this.userStore.user &&
        this.userFormElementsState.surnameValidation.isValid &&
        this.userFormElementsState.surname !== this.userStore.user.surname
      ) {
        await this.usersAPI.updateUser({
          _id: this.userStore.user._id,
          surname: this.userFormElementsState.surname,
        });
        await this.userStore.getCurrentUser();
      }
      this.userFormElementsState.surnameInputLock = true;
    },
    logout(){
      this.userStore.logout();
    }
  },
  watch: {
    "userFormElementsState.name"(newName) {
      const isEmpty = !newName;

      const errors = [];
      if (isEmpty) {
        errors.push("can't be empty");
      }

      this.userFormElementsState.nameValidation.isValid = !isEmpty;
      this.userFormElementsState.nameValidation.message = errors.join(", ");
    },

    "userFormElementsState.surname"(newName) {
      const isEmpty = !newName;

      const errors = [];
      if (isEmpty) {
        errors.push("can't be empty");
      }

      this.userFormElementsState.surnameValidation.isValid = !isEmpty;
      this.userFormElementsState.surnameValidation.message = errors.join(", ");
    },
  },
});
